import { TextParser } from '@features/lp/lp-text/parser/parser';
import { LpTextStyle } from '@typings/lp/generated';

export interface ITextParserContext {
  variables: Record<string, string | undefined>;
}

export class TextPart {
  public constructor(
    public readonly content: string,
    public readonly style: Record<string, any>,
  ) {}
}

export class Text {
  private get content() {
    return this.parts.map((part) => part.content).join('');
  }

  public get length() {
    return this.content.length;
  }

  public constructor(public readonly parts: TextPart[] = []) {}

  public static fromString(text: string, ctx: ITextParserContext) {
    return TextParser.parse(text, ctx);
  }

  public slice(start: number, end?: number): Text {
    const subParts: TextPart[] = [];

    end = end ?? this.length;

    let i = 0;
    for (const part of this.parts) {
      if (i + part.content.length < start) {
        i += part.content.length;
        continue;
      }

      if (i >= end) {
        break;
      }

      if (i < start && i + part.content.length > start) {
        subParts.push(new TextPart(part.content.substring(start - i), part.style));
      } else if (i >= start && i + part.content.length <= end) {
        subParts.push(part);
      } else if (i < end && i + part.content.length > end) {
        subParts.push(new TextPart(part.content.substring(0, end - i), part.style));
      }

      i += part.content.length;
    }

    return new Text(subParts);
  }

  public at(index: number) {
    return this.content.at(index);
  }
}

export function getFontSize(style: LpTextStyle) {
  return style === 'Small' ? '0.75em' : style === 'Header' ? '3.5em' : style === 'Subheader' ? '2em' : '1em';
}
